import { render, staticRenderFns } from "./StoreReview.vue?vue&type=template&id=0614321c&scoped=true"
import script from "./StoreReview.vue?vue&type=script&lang=js"
export * from "./StoreReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614321c",
  null
  
)

export default component.exports